import styled, {css} from 'styled-components';
import {BaseButton} from '../../helpers/base-button';
import {Color} from '../../tokens/colors';
import {Radius} from '../../tokens/radiuses';
import {Transition} from '../../tokens/transitions';

const ButtonSize = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};

const ButtonColor = {
    BLUE: 'blue',
    DARK_BLUE: 'darkBlue',
    RED: 'red',
    BORDER_BLUE: 'borderBlue',
};

const ButtonSizeToCSS = {
    [ButtonSize.SMALL]: css`
        padding: 5px 11px;
        font-size: 13px;
        font-weight: 600;
    `,
    [ButtonSize.MEDIUM]: css`
        padding: 9px 11px;
        font-size: 12px;
        font-weight: 600;
    `,
    [ButtonSize.LARGE]: css`
        padding: 12px 19px;
        font-size: 14px;
        font-weight: 400;
    `,
};

const ButtonColorToCSS = {
    [ButtonColor.BLUE]: css`
        --color-button: ${Color.GRAY_BLUE};

        color: ${Color.PRIMARY_BLUE};
        background-color: var(--color-button);

        &:hover,
        &:focus {
            --color-button: ${Color.GRAY_BLUE_HOVER};
        }

        &:active {
            --color-button: ${Color.GRAY_BLUE_ACTIVE};
        }

        &:disabled {
            --color-button: ${Color.ICON_GRAY};
        }
    `,
    [ButtonColor.DARK_BLUE]: css`
        --color-button: ${Color.PRIMARY_BLUE};

        color: ${Color.WHITE};
        background-color: var(--color-button);

        &:hover,
        &:focus {
            --color-button: ${Color.PRIMARY_BLUE_HOVER};
        }

        &:active {
            --color-button: ${Color.PRIMARY_BLUE_ACTIVE};
        }

        &:disabled {
            --color-button: ${Color.ICON_GRAY};
        }
    `,
    [ButtonColor.RED]: css`
        --color-button: ${Color.PRIMARY_RED};

        color: ${Color.WHITE};
        background-color: var(--color-button);

        &:hover,
        &:focus {
            --color-button: ${Color.PRIMARY_RED_HOVER};
        }

        &:active {
            --color-button: ${Color.PRIMARY_RED_ACTIVE};
        }

        &:disabled {
            --color-button: ${Color.ICON_GRAY};
        }
    `,
    [ButtonColor.BORDER_BLUE]: css`
        --color-button: ${Color.WHITE};

        color: ${Color.PRIMARY_BLUE};
        background-color: var(--color-button);
        border-color: ${Color.PRIMARY_BLUE} !important;

        &:hover,
        &:focus {
            --color-button: ${Color.GRAY_BLUE};
        }

        &:active {
            --color-button: ${Color.GRAY_BLUE_ACTIVE};
        }

        &:disabled {
            --color-button: ${Color.ICON_GRAY};
        }
    `,
};

const StyledButton = styled(BaseButton).attrs(({size, color}) => ({
    size: size || ButtonSize.MEDIUM,
    color: color || ButtonColor.BLUE,
}))`
    ${({size}) => ButtonSizeToCSS[size]}
    ${({color}) => ButtonColorToCSS[color]}

    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    line-height: 1.2;
    text-align: center;
    border: 1px solid transparent;
    border-radius: ${Radius.BUTTON};
    transition:
        color ${Transition['BUTTON']},
        background-color ${Transition['BUTTON']};

    svg {
        color: currentColor;
    }
`;

export {StyledButton as Button, ButtonSize, ButtonColor};
